import PropTypes from 'prop-types';

import { orderRow } from '../../utils/proptypes';
import OrderRow from '../OrderRow';

export default function OrderTable({ rows }) {
  const items = rows.map((row, index) => {
    const isPlan = !!row.included;
    return (
      <OrderRow
        className="order-row"
        row={row}
        isPlan={isPlan}
        // eslint-disable-next-line react/no-array-index-key
        key={index}
      />
    );
  });
  return (
    <tbody>
      {items}
    </tbody>
  );
}

OrderTable.propTypes = {
  rows: PropTypes.arrayOf(orderRow).isRequired
};
